import { render, staticRenderFns } from "./VDropdown.vue?vue&type=template&id=305b2ec8&"
import script from "./VDropdown.vue?vue&type=script&lang=ts&"
export * from "./VDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./VDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports